module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b3194e4bba87be45fbc83d3029fc7926.png";